function addAllSettings(settings) {
  return {
    type: "ADD_SETTINGS",
    payload: settings,
  };
}

export { addAllSettings };
